module.exports = __webpack_public_path__ + "img/04_uk.fe508df2.svg";